import Resource from 'Resources/Resource';

export interface CompanySummary {
	about: string;
}

class AIResource extends Resource {
	constructor() {
		super('ai/completions', null);
	}

	async getCompanySummary(prospectingId: string): Promise<CompanySummary> {
		return this.get(`companySummary/${prospectingId}`);
	}
}

const resource = new AIResource();

export default resource;
